import { useCallback } from 'react';
import { useNavComponentsManager } from './useNavComponentsManager';

/**
 * Usage is similar to Reactive Variables from Apollo Client
 * const myComponentProps = useComponentProps(componentDef);
 *
 * // Getter
 * const currentProps = myComponentProps()
 *
 * // Setter
 * myComponentProps({ a: 1 });
 */
export const useComponentProps = componentDef => {
  const {
    getComponentProps,
    setComponentProps
  } = useNavComponentsManager();
  return useCallback(
  // eslint-disable-next-line consistent-return
  props => {
    if (typeof props === 'undefined') {
      return getComponentProps(componentDef);
    }
    setComponentProps(componentDef, props);
    return getComponentProps(componentDef);
  }, [componentDef, getComponentProps, setComponentProps]);
};